import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=6a202952&"
import script from "./BaseOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports